<template>
  <div class="payerDetails">
    <!--    缴款人详情-->
    <div class="navTitle">
      <van-icon name="arrow-left" @click="$router.go(-1)"/>
      缴款人详情
    </div>
    <div class="payerDetails_body">
      <div>
        <div v-for="(item,index) in fieldList" :key="index">
          <h2>
            {{ item.showName }}
          </h2>
          <h3 v-if="item.fieldType  == 2|| item.fieldType  == 7">{{ payerData[item.fieldName + 'Name'] }}</h3>
          <h4 v-if="item.fieldType  == 12" style="width: 100%;">
            <span v-for="(it,i) in payerData[item.fieldName]" :key="i">
              {{ it.ruleName }}
              <span v-if="i<payerData[item.fieldName].length -1 ">,</span>
            </span>
          </h4>
          <h3 v-if="item.fieldType != 2 && item.fieldType != 7 && item.fieldType != 3">{{
              payerData[item.fieldName + 'show']
            }}</h3>
          <h3 v-if="item.fieldType == 0 || item.fieldType == 3 || item.fieldType == 4|| item.fieldType == 6 || item.fieldType == 9"  >{{
              payerData[item.fieldName]
            }}</h3>
        </div>
      </div>
    </div>
    <div class="payerDetails_foot">
      <h2 @click.stop='selfCount'>手动计费</h2>
      <h2 @click.stop='generPay'>按量计费</h2>

      <van-popover
          v-model="showPopover"
          trigger="click"
          :actions="actions"
          @select="onSelect"
          placement="top"
          :offset="[-20,8]"
      >
        <template #reference>
          <span class="more">更多</span>
        </template>
      </van-popover>
    </div>

    <!-- 手动计费弹窗 -->
    <span class="detailTC">
      <van-popup
          class="showD"
          @click="closeDialog"
          v-model="showModel"
      >
        <div
            class="content2"
            @click.stop=''
            v-if="showModel"
        >
          <div class="ti">
            <img
                class="tiPic"
                :src="require('../../assets/img/selfPic.png')"
                alt
            />
          </div>
          <div class="add_content">
            <van-form>
              <div :class="'isRecessary'">
                <van-field
                    readonly
                    :value="saveBody.ruleName"
                    input-align="right"
                    clickable
                    name="picker"
                    :label="'计费规则'"
                    :placeholder="'请选择'"
                    right-icon="arrow"
                    @click="openPickOne"
                />

              </div>


              <!-- 默认年月 -->
              <div v-if="ruleType=='1'" :class="'isRecessary'">
                <van-field
                    readonly
                    :value="saveBody.startDateName"
                    input-align="right"
                    clickable
                    name="picker"
                    :label="'计费开始时间'"
                    :placeholder="'请选择'"
                    right-icon="arrow"
                    @click="onClickMonthStart"
                />
              </div>
              <div v-if="ruleType=='1'" :class="'isRecessary'">
                <van-field
                    readonly
                    input-align="right"
                    clickable
                    :value="saveBody.endDateName"
                    name="picker"
                    :label="'计费结束时间'"
                    :placeholder="'请选择'"
                    right-icon="arrow"
                    @click="onClickMonthEnd"
                />
              </div>

              <!-- 默认年 -->
              <div v-if="ruleType=='2'" :class="'isRecessary'">
                <van-field
                    readonly
                    :value="saveBody.startDateName"
                    input-align="right"
                    clickable
                    name="picker"
                    :label="'计费开始时间'"
                    :placeholder="'请选择'"
                    right-icon="arrow"
                    @click="onPickerYearStart"
                />
              </div>
              <div v-if="ruleType=='2'" :class="'isRecessary'">
                <van-field
                    readonly
                    input-align="right"
                    clickable
                    :value="saveBody.endDateName"
                    name="picker"
                    :label="'计费结束时间'"
                    :placeholder="'请选择'"
                    right-icon="arrow"
                    @click="onPickerYearEnd"
                />
              </div>

              <!-- 3是季度 -->
              <div v-if="ruleType=='3'" :class="'isRecessary'">
                <van-field
                    readonly
                    :value="saveBody.startDateName"
                    input-align="right"
                    clickable
                    name="picker"
                    :label="'计费开始时间'"
                    :placeholder="'请选择'"
                    right-icon="arrow"
                    @click="openSeasonStart"
                />
              </div>
              <div v-if="ruleType=='3'" :class="'isRecessary'">
                <van-field
                    readonly
                    input-align="right"
                    clickable
                    :value="saveBody.endDateName"
                    name="picker"
                    :label="'计费结束时间'"
                    :placeholder="'请选择'"
                    right-icon="arrow"
                    @click="openSeasonEnd"
                />
              </div>

              <!-- 年月日 -->
              <div v-if="ruleType=='4'" :class="'isRecessary'">
                <van-field
                    readonly
                    :value="saveBody.startDateName"
                    input-align="right"
                    clickable
                    name="picker"
                    :label="'计费开始时间'"
                    :placeholder="'请选择'"
                    right-icon="arrow"
                    @click="onClickDate"
                />
              </div>
              <div v-if="ruleType=='4'" :class="'isRecessary'">
                <van-field
                    readonly
                    input-align="right"
                    clickable
                    :value="saveBody.endDateName"
                    name="picker"
                    :label="'计费结束时间'"
                    :placeholder="'请选择'"
                    right-icon="arrow"
                    @click="onClickDateEnd"
                />
              </div>
            </van-form>
          </div>

          <div
              class="editStudent"
              style="margin-bottom: 0px;"
              @click.stop="selfCountGener"
          >
            <span>
              手动计费
            </span>
          </div>

        </div>
      </van-popup>
    </span>
    <!-- 计费规则 -->
    <van-popup
        v-model="showPickerOne"
        position="bottom"
    >
      <van-picker
          ref="van_rule_picker"
          show-toolbar
          :columns="ruleList"
          @confirm="onConfirmOne"
          @cancel="showPickerOne = false"
      />
    </van-popup>
    <!-- 开始年月 -->
    <van-popup
        v-model="showPickerMonthStart"
        position="bottom"
    >
      <van-datetime-picker
          v-model="saveBody.startDate"
          type="year-month"
          title="选择年月"
          @confirm="onConfirmMonthStart"
          @cancel="showPickerMonthStart = false"
      />
    </van-popup>
    <van-popup
        v-model="showPickerMonthEnd"
        position="bottom"
    >
      <van-datetime-picker
          v-model="saveBody.endDate"
          type="year-month"
          title="选择年月"
          @confirm="onConfirmMonthEnd"
          @cancel="showPickerMonthEnd = false"
      />
    </van-popup>
    <!-- 开始年 -->
    <van-popup
        v-model="showPickerYearStart"
        position="bottom"
    >
      <van-picker
          ref="van_yearSt_picker"
          show-toolbar
          title="选择年"
          :columns="yearList"
          @confirm="onConfirmYearStart"
          @cancel="showPickerYearStart = false"
      />
    </van-popup>
    <van-popup
        v-model="showPickerYearEnd"
        position="bottom"
    >
      <van-picker
          ref="van_yearEn_picker"
          show-toolbar
          title="选择年"
          :columns="yearList"
          @confirm="onConfirmYearEnd"
          @cancel="showPickerYearEnd = false"
      />
    </van-popup>
    <!-- 开始年季度 -->
    <van-popup
        v-model="showPickerSeasonStart"
        position="bottom"
    >
      <van-picker ref='season_start' show-toolbar title="选择年季度" :columns="seasonList"  @confirm="onConfirmSeasonStart"
                  @cancel="showPickerSeasonStart = false"/>
    </van-popup>
    <van-popup
        v-model="showPickerSeasonEnd"
        position="bottom"
    >
      <van-picker ref='season_end' show-toolbar title="选择年季度" :columns="seasonList"  @confirm="onConfirmSeasonEnd"
                  @cancel="showPickerSeasonEnd = false"/>
    </van-popup>
    <!-- 开始年月日 -->
    <van-popup
        v-model="showPickerStart"
        position="bottom"
    >
      <van-datetime-picker
          v-model="saveBody.startDate"
          type="date"
          title="选择年月日"
          @confirm="onConfirmStart"
          @cancel="showPickerStart = false"
      />
    </van-popup>
    <van-popup
        v-model="showPickerEnd"
        position="bottom"
    >
      <van-datetime-picker
          v-model="saveBody.endDate"
          type="date"
          title="选择年月日"
          @confirm="onConfirmEnd"
          @cancel="showPickerEnd = false"
      />
    </van-popup>
    <div class="codedialog">
      <van-popup
          v-model="QrcodeDialogVisible"
          round
          :close-on-click-overlay="false"
          :get-container="getContainer"
      >
        <div class="wrap">
          <div class="content">
            <!-- <div class="circle"></div> -->
            <div class="ti">
              <div class="tiLogo">
                <div
                    id="qrCode"
                    ref="qrCodeDiv"
                    style="margin: 0 auto; width: 154px"
                ></div>
              </div>
              <!-- 支付提醒 -->
              <!-- <div class="close" @click="closeDialog">×</div> -->
            </div>
            <div class="qrCenter">支持支付宝、微信扫码</div>
            <div class="qrContent">
              <div class="qc_top">
                <span>缴款人</span>
                <span>{{ paymentUnit }}</span>
              </div>
              <div class="qc_bot">
                <span>缴款金额</span>
                <span class="qc_money">¥{{ paymentTotal }}</span>
              </div>
            </div>
            <div class="butarea">
              <!-- <div class="rbutton cancel">取消支付</div> -->
              <van-button
                  @click="confirmData"
                  block
                  class="confirm"
                  round
                  type="info"
              >确认
                <!-- <img
                  class="blueSha"
                  src="../../assets/img/blueshadow.png"
                  alt=""
                /> -->
              </van-button>
            </div>
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import {
  formatterDate, formatterMonth, formatterSureDate, getUser,
  isEmpty,
} from "@/utils/common";
import SearchList from "@/components/list/searchList";
import QRCode from "qrcodejs2";
import { Dialog, Notify, Toast } from "vant";

export default {
  name: "payerDetails",
  components: {
    SearchList
  },
  data() {
    return {
      QrcodeDialogVisible:false,
      paymentUnit:'',
      paymentTotal:'',
      fieldList: [],
      defaultFieldList: [],
      payerData: {},
      showPopover: false,
      actions: [
        {text: '修改'}, {text: '停用'}, {text: '删除'}
      ],
      state:'',
      showModel:false,
      saveBody:{
        ruleId:'',
        ruleName:'',
        startDate:new Date(),
        startDateName:'',
        endDate:new Date(),
        endDateName:''
      },
      showPickerStart:false,
      showPickerEnd:false, // 年月日
      showPickerOne:false, // 年月日

      showPickerMonthStart:false, //年月
      showPickerMonthEnd:false, // 年月

      showPickerSeasonStart:false, //年季度
      showPickerSeasonEnd:false, // 年季度

      showPickerYearStart:false, //年
      showPickerYearEnd:false, // 年

      ruleList:[],
      payerRuleList:[],
      payerId:'',
      ruleType:'1',
      yearList:[],
      seasonList:[],
    }
  },
  created() {
    this.getDetails()
  },
  mounted() {
    // this.$route.query.isEnable
    this.actions[1] = this.$route.query.isEnable == 1 ? {text: '停用'} : {text: '启用'}
    this.getYearArray();
    this.getSeasonArray();
  },
  methods: {
    generPay(){
      let {vde,uId,isEnable} = this.$route.query;
      this.$router.push({
        path:'/businessIndex/garbageGenerate',
        query:{
          vde,
          uId,
          isEnable
        }
      })
    },
    openSeasonStart(){
      this.showPickerSeasonStart=true
      let index = 0;

      if (this.saveBody.startDate) {
        index = this.seasonList.findIndex((val) => {
          if(this.saveBody.startDate){
            // return val.text == new Date(this.saveBody.startDate).getFullYear()+'年';
            if(this.saveBody.startDate.indexOf('-')>-1){
              let str=this.saveBody.startDate;
              let start1=str.split('-')[0].slice(0,4)
              return val.text == new Date(start1).getFullYear()+'年';
            }else{
              return val.text == new Date(this.saveBody.startDate).getFullYear()+'年';

            }
          }else{
            return val.text == new Date().getFullYear()+'年';
          }
        });
      } else {
        index = 0;
        index = this.seasonList.findIndex((val) => {
          return val.text == new Date().getFullYear()+'年';
        });
      }
      setTimeout(() => {
        // 使用setIndexes方法设置选中项
        if (this.$refs.season_start) {
          console.log(this.$refs.season_start);
          this.$nextTick(() => {
            this.$refs.season_start.setIndexes([index]);
          });
        }
      });
    },
    openSeasonEnd(){
      this.showPickerSeasonEnd=true;
      let index = 0;
      console.log(this.saveBody.endDate);

      if (this.saveBody.endDate) {
        index = this.seasonList.findIndex((val) => {
          if(this.saveBody.endDate){
            if(this.saveBody.endDate.indexOf('-')>-1){
              let str=this.saveBody.endDate;
              let start1=str.split('-')[0].slice(0,4)
              return val.text == new Date(start1).getFullYear()+'年';
            }else{
              return val.text == new Date(this.saveBody.endDate).getFullYear()+'年';

            }

          }else{
            return val.text == new Date().getFullYear()+'年';
          }

        });
      } else {
        index = 0;
        index = this.seasonList.findIndex((val) => {
          return val.text == new Date().getFullYear()+'年';
        });
      }
      setTimeout(() => {
        // 使用setIndexes方法设置选中项
        if (this.$refs.season_end) {
          console.log(this.$refs.season_end);
          this.$nextTick(() => {
            this.$refs.season_end.setIndexes([index]);
          });
        }
      });
    },
    // 获取年季度数组
    getSeasonArray() {
      const date = new Date();
      const currentYear = date.getFullYear() + 10;
      const yearArray = [];
      // 入学年度，最多录入当年的
      const lastYear = currentYear;
      for (let i = lastYear; i >= 1900; i--) {
        let obj = {
          text: i.toString()+'年',
          children:[{
            text:'第一季度'
          },{
            text:'第二季度'
          },{
            text:'第三季度'
          },{
            text:'第四季度'
          }]
        };
        yearArray.push(obj);
      }
      this.seasonList= yearArray.reverse();
    },

    onClickDate(){
      this.showPickerStart=true;
      if (this.saveBody.startDate) {

      } else {
        this.saveBody.startDate=new Date();
      }

    },
    onClickDateEnd(){
      this.showPickerEnd=true;
      if (this.saveBody.endDate) {

      } else {
        this.saveBody.endDate=new Date();
      }

    },

    onClickMonthStart(){
      this.showPickerMonthStart=true;
      if (this.saveBody.startDate) {

      } else {
        this.saveBody.startDate=new Date();
      }
    },
    onClickMonthEnd(){
      this.showPickerMonthEnd=true;
      if (this.saveBody.endDate) {

      } else {
        this.saveBody.endDate=new Date();
      }
    },

    // 年份选择
    onPickerYearEnd(){
      this.showPickerYearEnd=true
      let index = 0;
      if (this.saveBody.endDate) {
        index = this.yearList.findIndex((val) => {
          return val.value == this.saveBody.endDate;
        });
      } else {
        index = 0;
        index = this.yearList.findIndex((val) => {
          return val.value == new Date().getFullYear();
        });
      }
      setTimeout(() => {
        // 使用setIndexes方法设置选中项
        if (this.$refs.van_yearEn_picker) {
          console.log(this.$refs.van_yearEn_picker);
          this.$nextTick(() => {
            this.$refs.van_yearEn_picker.setIndexes([index]);
          });
        }
      });
    },
    // 年份选择
    onPickerYearStart(){
      this.showPickerYearStart=true
      let index = 0;
      if (this.saveBody.startDate) {
        index = this.yearList.findIndex((val) => {
          return val.value == this.saveBody.startDate;
        });
      } else {
        index = 0;
        index = this.yearList.findIndex((val) => {
          return val.value == new Date().getFullYear();
        });
      }
      setTimeout(() => {
        // 使用setIndexes方法设置选中项
        if (this.$refs.van_yearSt_picker) {
          console.log(this.$refs.van_yearSt_picker);
          this.$nextTick(() => {
            this.$refs.van_yearSt_picker.setIndexes([index]);
          });
        }
      });
    },
    // 获取年份数组
    getYearArray() {
      const date = new Date();
      const currentYear = date.getFullYear() + 10;
      const yearArray = [];
      // 入学年度，最多录入当年的
      const lastYear = currentYear;
      for (let i = lastYear; i >= 1900; i--) {
        let obj = {
          value: i.toString(),
          text: i.toString(),
        };
        yearArray.push(obj);
      }
      this.yearList= yearArray.reverse();
    },
    onSelect(action) {
      console.log(action.text)
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0
      })
      if (action.text == '删除') {
        this.$CDialog({
          confirmBtnText: "确认",
          cancelBtnText: '取消',
          title: "提示",
          status: "2",
          textSize: 16,
          message: '是否确认删除该缴款人',
        }).then(() => {
          this.request({
            url: '/business/deletePayer',
            method: 'post',
            data: [this.$route.query.uId]
          }).then(res => {
            let data = res.data
            if (data.code == 1000) {
              this.$router.go(-1)
            } else {
              this.$CDialog({
                confirmBtnText: "确认",
                title: "提示",
                status: "2",
                textSize: 16,
                message: data.message,
              })
            }
          })
        }).catch(() => {

        })

      }
      if (action.text == '停用' || action.text == '启用') {
        this.request({
          url: '/business/updatePayerState',
          params: {
            uId: this.$route.query.uId,
            state: this.$route.query.isEnable == 1 ? '0' : '1'
          }
        }).then(res => {
          let data = res.data
          if (data.code == 1000) {
            this.$router.go(-1)
          } else {
            this.$CDialog({
              confirmBtnText: "确认",
              title: "提示",
              status: "2",
              textSize: 16,
              message: data.message,
            })
          }
        })
      }
      if (action.text == '修改') {
        // localStorage.setItem('payerData', JSON.stringify(this.payerData))
        let arr = []
        this.payerData.ruleList.map(item => {
          arr.push(item.ruleId)
        })
        let obj = {
          checkRule:arr,
          ruleList:this.payerData.ruleName
        }

        localStorage.setItem('checkdObj',JSON.stringify(obj))
        this.$router.push({
          path: '/bussiess/payerAllocation',
          query: {
            type: '修改',
            uId: this.$route.query.uId
          }
        })
      }

      this.$toast.clear()

    },
    getDetails() {
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0
      })
      this.request({
        url: '/business/getPayerDetail',
        params: {
          path: '/business/payerManageData',
          type: 'h5',
          uId: this.$route.query.uId
        }
      }).then(res => {
        this.$toast.clear()

        let data = res.data
        if (data.code == 1000) {
          this.payerData = data.result
          localStorage.setItem('payerData', JSON.stringify(data.result))

          if(this.payerData){
            this.payerId=this.payerData.uId;
            setTimeout(() => {
              this.getFieldList()
            },500)
          }
        }
        else {
          this.$CDialog({
            confirmBtnText: "确认",
            title: "提示",
            status: "2",
            textSize: 16,
            message: data.message,
          }).then(() => {
            this.$router.go(-1)
          })
        }
      })
    },
    getDictionaryData(url, data) {
      return this.request({
        url: url,
        method: "get",
        params: data
      }).then(res => {
        if (res.data.code == 1000) {
          return res.data.result;
        }
      });
    },
    getFieldList() {
      this.request({
        url: '/busFieldConfig/getPayerField',
        params: {
          deptId: getUser().deptId,
          type: 1
        }
      }).then(res => {
        console.log(res.data)
        if (res.data.code == 1000) {
          this.fieldList = res.data.result
          let arr = [
            {
              "showName": "计费面积",
              "fieldName": "chargingAreaField",
              "fieldType": "0",
            },
            {
              "showName": "计费户数",
              "fieldName": "chargingHouseholds",
              "fieldType": "0",
            },
            {
              "showName": "计费规则",
              "fieldName": "ruleList",
              "fieldType": "12",
            },
            {
              "showName": "开始计费日期",
              "fieldName": "chargingStartDate",
              "fieldType": "0",
            },
            {
              "showName": "费用结束月份",
              "fieldName": "costEndMonth",
              "fieldType": "0",
            },
          ]
          this.fieldList.push(...arr)
          this.fieldList.map(item => {
            if (item.fieldType == "2") {
              let url =
                  "/system/dictionary/listDictData/" + item.dictionary;
              let data = {};
              this.getDictionaryData(url, data).then(result => {
                result.map(it => {
                  if (it.value == this.payerData[item.fieldName]) {
                    this.payerData[item.fieldName + 'Name'] = it.label
                  }
                })
              });
            }
            if (item.fieldType == "7") {
              let url = "/system/dictDeptData/listDictDeptData";
              let data = {deptId: getUser().deptId, dictType: item.dictionary};
              this.getDictionaryData(url, data).then(result => {
                result.map(it => {
                  if (it.value == this.payerData[item.fieldName]) {
                    this.payerData[item.fieldName + 'Name'] = it.label
                  }
                })
              });
            }
            if (item.fieldType == "10") {
              let data = {
                dictId:item.dictionary,
              }
              data.isdel = item.dictionary ? true : false
              this.request({
                url: '/deptCascadeDictData/listDeptCascadeDictDataTree',
                params: data
              }).then(res => {
                let data = this.flattenTree(res.data.result)
                let arr =  []
                if(typeof eval(this.payerData[item.fieldName] == 'object')){
                  arr = eval(this.payerData[item.fieldName])
                }
                let str = ''
                data&& data?.map(it => {
                  Array.isArray(arr) &&  arr?.map(i => {
                    if(it.uId == i){
                      str += it.dictName
                    }
                  })
                })
                setTimeout(() => {
                  this.$nextTick(() => {
                    this.payerData[item.fieldName + 'show'] = str
                    this.$forceUpdate()
                  })
                },500)

              })
            }
          })

        }
      })
    },
    flattenTree(tree) {
      let result = []; // 存放最后的扁平化数组

      function traverseNode(node) {
        if (Array.isArray(node)) {
          node.forEach((child) => {
            traverseNode(child);
          });
        } else {
          result.push(node);

          if (node.children && Array.isArray(node.children)) {
            node.children.forEach((child) => {
              traverseNode(child);
            });
          }
        }
      }

      traverseNode(tree);

      return result;
    },
    // 手动计费
    selfCount(){
      this.getRulers();


    },

    // 手动计费调用生成数据
    selfCountGener(){
      let data = {
        ruleId: this.saveBody.ruleId,
        startDateName: this.saveBody.startDateName,
        endDateName: this.saveBody.endDateName,
      };
      let keysForm = Object.keys(data);
      for (let i = 0; i < keysForm.length; i++) {
        let value = this.saveBody[keysForm[i]];
        if (isEmpty(value)) {
          let showName = "";
          if (keysForm[i] == "endDateName") {
            showName = "计费结束时间";
          } else if (keysForm[i] == "startDateName") {
            showName = "计费开始时间";
          } else if (keysForm[i] == "ruleId") {
            showName = "计费规则";
          }
          this.$CDialog({
            confirmBtnText: "确认",
            title: "提示",
            status: "2",
            textSize: 16,
            message: showName + "不能为空",
          }).then((res) => {});
          return;
        }
      }
      let data1={};
      if(this.ruleType=='3'){
        data1={
          "ruleId": this.saveBody.ruleId,
          "payerList": [{
            uId: this.payerData.uId,
            chargingStartDate: this.payerData.chargingStartDate,
            paymentUnit:this.payerData.paymentUnit,
            isEnable:this.payerData.isEnable
          }],
          "kz1": this.saveBody.startDate.split('-')[0].slice(0,4)+'-'+this.saveBody.startDate.split('-')[1],
          "kz2": this.saveBody.endDate.split('-')[0].slice(0,4)+'-'+this.saveBody.endDate.split('-')[1],
          chargingCycle:this.ruleType
        };
        let start = new Date(this.saveBody.startDate.split('-')[0].slice(0,4)+'-0'+this.saveBody.startDate.split('-')[1]).getTime();
        let end = new Date( this.saveBody.endDate.split('-')[0].slice(0,4)+'-0'+this.saveBody.endDate.split('-')[1]).getTime();
        if (start > end) {
          this.$CDialog({
            confirmBtnText: "确认",
            title: "提示",
            status: "2",
            textSize: 16,
            message: "开始时间不能大于结束时间",
          }).then((res) => {});
          return;
        }
      }else{
        data1={
          "ruleId": this.saveBody.ruleId,
          "payerList": [{
            uId: this.payerData.uId,
            chargingStartDate: this.payerData.chargingStartDate,
            paymentUnit:this.payerData.paymentUnit,
            isEnable:this.payerData.isEnable
          }],
          "kz1":this.formatDate(new Date(this.saveBody.startDate)),
          "kz2": this.formatDate(new Date(this.saveBody.endDate)),
          chargingCycle:this.ruleType
        };
        if(this.ruleType=='1'){
          data1.kz1=formatterMonth(new Date(this.saveBody.startDate));
          data1.kz2=formatterMonth(new Date(this.saveBody.endDate));
        }
        if(this.ruleType=='2'){
          data1.kz1=new Date(this.saveBody.startDate).getFullYear().toString();
          data1.kz2=new Date(this.saveBody.endDate).getFullYear().toString();
        }
        let start = new Date(this.saveBody.startDate).getTime();
        let end = new Date(this.saveBody.endDate).getTime();


        if (start > end) {
          this.$CDialog({
            confirmBtnText: "确认",
            title: "提示",
            status: "2",
            textSize: 16,
            message: "开始时间不能大于结束时间",
          }).then((res) => {});
          return;
        }

      }


      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      })
      this.request({
        url:'/business/h5ManualGenerationData',
        method:'post',
        data:data1
      }).then(res=>{
        Toast.clear();
        if(res.data.code==1000){
          this.closeDialog();
          this.$CDialog({
            confirmBtnText: "二维码缴费", //按钮文字
            title: "提示", //title提示文字
            textSize: 16,
            isGarbarge: true,
            message: `已成功生成${res.data.result?res.data.result.length:0}条待缴费数据！`, //弹窗内容
            status: "2", //显示哪种图   1 为绿色   2为蓝色
            cancelBtnText: "稍后自行缴费",
          })
              .then((response) => {
                console.log(1,2);
                this.getcode(res.data.result);
              })
              .catch((err) => {
              });
        }else{
          let str = "确认";
          if (res.data.errorMessage) {
            str = "查看错误详情";
            this.$CDialog({
              confirmBtnText: str,
              title: "提示",
              status: "2",
              message: res.data.message,
            }).then(() => {
              this.$CTips({
                title: "错误提示",
                message: res.data.errorMessage,
                clickOverlay: false,
              });
            });
          } else {
            this.$CDialog({
              confirmBtnText: str,
              title: "提示",
              status: "2",
              message: res.data.message,
            });
          }
        }
      })
    },
    confirmData(){
      this.QrcodeDialogVisible = false;
    },
    // 生成二维码
    getcode(item) {
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
      let uIds=item;
      this.request({
        url:'/garbageOutput/getQrcodeUrl',
        method:'post',
        data:uIds
      }).then((res) => {
        Toast.clear();
        if (res.data.code === 1000) {
          // 获取返回的二维码连接地址
          this.QrcodeDialogVisible = true;
          setTimeout(() => {
            document.getElementById("qrCode").innerHTML = "";
            new QRCode(this.$refs.qrCodeDiv, {
              text: res.data.result.qrCodeUrl,
              width: 160,
              height: 160,
              colorDark: "#333333", // 二维码颜色
              colorLight: "#ffffff", // 二维码背景色
              correctLevel: QRCode.CorrectLevel.L, // 容错率，L/M/H
            });
          }, 100);
          setTimeout(() => {
            $(".codedialog .van-dialog__header").css({
              background: "#2D53EB",
              color: "#fff",
            });
          });
          this.paymentUnit=res.data.result.paymentUnit;
          this.paymentTotal=res.data.result.paymentTotal;
        } else {
          this.$CDialog({
            confirmBtnText: "确认",
            title: "提示",
            message: res.data.message,
            status: "2",
            textSize: 16,
          }).then((res) => {});
        }
      });
    },
    getContainer() {
      return document.querySelector(".codedialog");
    },
    getRulers() {
      // 获取对应缴款人关联的规则
      this.request({
        url: "/business/filterSameRules",
        method: "post",
        data:  [this.payerData],
      }).then((res) => {
        if (res.data.code == 1000) {
          this.showModel=true;
          this.saveBody={
            startDate:'',
            endDate:'',
            startDateName:'',
            endDateName:'',
            ruleName:'',
            ruleId:''
          };
          this.payerRuleList = res.data.result || [];
          this.ruleList = [];
          if (this.payerRuleList.length > 0) {
            this.payerRuleList.forEach((item) => {
              this.ruleList.push({
                value: item.ruleId,
                text: item.ruleName,
                type:item.chargingCycle
              });
            });
          }
          console.log(this.ruleList);
        } else {
          let str = "确认";
          if (res.data.errorMessage) {
            str = "查看错误详情";
            this.$CDialog({
              confirmBtnText: str,
              title: "提示",
              status: "2",
              message: res.data.message,
            }).then(() => {
              this.$CTips({
                title: "错误提示",
                message: res.data.errorMessage,
                clickOverlay: false,
              });
            });
          } else {
            this.$CDialog({
              confirmBtnText: str,
              title: "提示",
              status: "2",
              message: res.data.message,
            });
          }
        }
      });
    },
    closeDialog() {
      this.showModel = false;
    },

    onConfirmStart(date) {
      console.log(date);
      this.showPickerStart = false;
      this.saveBody.startDateName = this.formatDate(date);
      this.saveBody.startDate = this.formatDate(date);
    },
    onConfirmEnd(date) {
      this.showPickerEnd = false;
      this.saveBody.endDateName = this.formatDate(date);
      this.saveBody.endDate = this.formatDate(date);
    },


    onConfirmMonthStart(date) {
      this.showPickerMonthStart = false;
      this.saveBody.startDateName = formatterMonth(date);
      this.saveBody.startDate = formatterMonth(date);
      console.log(this.saveBody);

    },
    onConfirmMonthEnd(date) {
      this.showPickerMonthEnd = false;
      this.saveBody.endDateName = formatterMonth(date);
      this.saveBody.endDate = formatterMonth(date);
    },

    onConfirmYearStart(date) {
      this.showPickerYearStart = false;
      this.saveBody.startDateName = date.value;
      this.saveBody.startDate = date.value;
    },
    onConfirmYearEnd(date) {
      this.showPickerYearEnd = false;
      this.saveBody.endDateName = date.value;
      this.saveBody.endDate = date.value;
    },
    onConfirmSeasonStart(date){
      this.showPickerSeasonStart = false;
      this.saveBody.startDateName = date[0]+date[1];
      if(date[1]){
        if(date[1]=='第一季度'){
          this.saveBody.startDate = date[0]+'-01';
        }else if(date[1]=='第二季度'){
          this.saveBody.startDate = date[0]+'-02';
        }else if(date[1]=='第三季度'){
          this.saveBody.startDate = date[0]+'-03';
        }else if(date[1]=='第四季度'){
          this.saveBody.startDate = date[0]+'-04';
        }
      }else{
        this.saveBody.startDate = '';
      }
    },
    onConfirmSeasonEnd(date){
      this.showPickerSeasonEnd = false;
      this.saveBody.endDateName = date[0]+date[1];
      if(date[1]){
        if(date[1]=='第一季度'){
          this.saveBody.endDate = date[0]+'-01';
        }else if(date[1]=='第二季度'){
          this.saveBody.endDate = date[0]+'-02';
        }else if(date[1]=='第三季度'){
          this.saveBody.endDate = date[0]+'-03';
        }else if(date[1]=='第四季度'){
          this.saveBody.endDate = date[0]+'-04';
        }
      }else{
        this.saveBody.endDate = '';
      }
    },

    formatDate(date) {
      return formatterDate(date);
    },

    openPickOne() {
      this.showPickerOne = true;
      let index = 0;
      if (this.saveBody.ruleId) {
        index = this.ruleList.findIndex((val) => {
          return val.value == this.saveBody.ruleId;
        });
      } else {
        index = 0;
      }
      setTimeout(() => {
        // 使用setIndexes方法设置选中项
        if (this.$refs.van_rule_picker) {
          console.log(this.$refs.van_rule_picker);
          this.$nextTick(() => {
            this.$refs.van_rule_picker.setIndexes([index]);
          });
        }
      });
    },
    onConfirmOne(value) {
      if (value) {
        this.saveBody.ruleName = value.text;
        this.saveBody.ruleId = value.value;
        this.ruleType= value.type;
        this.saveBody.startDateName='';
        this.saveBody.endDateName= '';
        this.saveBody.startDate= '';
        this.saveBody.endDate= '';
        // if(this.ruleType=='2'){
        //   this.saveBody.startDateName= new Date().getFullYear();
        //   this.saveBody.endDateName= new Date().getFullYear();
        //   this.saveBody.startDate= new Date().getFullYear();
        //   this.saveBody.endDate= new Date().getFullYear();
        // }

      } else {
        this.saveBody.ruleName = "";
        this.saveBody.ruleId = "";
      }
      this.showPickerOne = false;
    },
  }
}
</script>

<style lang="scss" scoped>
.payerDetails {
  height: 100vh;
  ::v-deep .van-picker-column__item {
    color: rgba(70, 74, 76, 0.7);
    font-weight: 400;

    font-size: 18px;
    letter-spacing: 0;
  }

  ::v-deep .van-picker-column__item--selected {
    color: #464a4c;
    font-weight: 500;

    font-size: 20px;
    letter-spacing: 0;
  }

  ::v-deep .van-picker__cancel {
    color: #464a4c;
    font-weight: 500;

    font-size: 16px;
    letter-spacing: 0;
  }

  ::v-deep .van-picker__confirm {
    color: #208fff;
    font-weight: 500;

    font-size: 16px;
    letter-spacing: 0;
  }
  .navTitle {
    height: 44px;
    position: relative;
    text-align: center;
    line-height: 44px;
    font-size: 17px;
    color: #333333;
    letter-spacing: 0;
    font-weight: 500;

    i {
      position: absolute;
      left: 16px;
      top: 16px;
    }
  }

  .payerDetails_body {
    width: 100%;
    height: calc(100vh - 120px);
    overflow: auto;
    background-image: linear-gradient(180deg, #EFEFEF 0%, #FCFCFC 95%);
    border-radius: 0px;
    padding-top: 10px;

    > div {
      margin: 0 16px;
      background: #fff;
      border-radius: 10px;
      padding-bottom: 4px;
      > div {
        padding: 15px 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 20px;
        box-shadow: 0px -1px 0px 0px rgba(238, 238, 238, 0.5);
        box-shadow: 0px 1px 0px 0px rgba(238, 238, 238, 0.5);

        h2 {
          font-size: 16px;
          color: #464A4C;
          letter-spacing: 0;
          line-height: 22px;
          font-weight: 400;
          min-width: 100px;
          width: 100px;
          white-space: nowrap;
        }

        h3, h4 {
          flex: 1 1 auto;
          line-height: 1;
          font-size: 16px;
          color: #333333;
          letter-spacing: 0;
          text-align: right;
          font-weight: 400;
          word-break: break-word;
        }

        h4 {
          line-height: 20px;
        }
      }
    }
  }

  .payerDetails_foot {
    position: fixed;
    width: 100%;
    bottom: 0;
    height: 64px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    background: #FFFFFF;
    box-shadow: 0px -5px 10px 0px rgba(0, 0, 0, 0.05);
    padding-right: 16px;

    h2 {
      background-image: linear-gradient(-67deg, #54ADFB 0%, #297BF4 100%);
      border-radius: 22px;
      width: 96px;
      line-height: 40px;
      height: 40px;
      text-align: center;
      font-size: 16px;
      color: #FFFFFF;
      letter-spacing: 0;
      font-weight: 500;
      margin-right: 10px;
    }

    .more {
      background: #fff;
      display: block;
      width: 64px;
      text-align: center;
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      color: #333333;
      letter-spacing: 0;
      font-weight: 400;
      border: 1px solid rgba(204, 204, 204, 1);
      border-radius: 22px;
    }
  }
}

.detailTC {
  ::v-deep .van-overlay {
    background: transparent;
  }
  ::v-deep .msgClass {
    font-size: 14px !important;
  }

  .ti {
    position: relative;
    margin-bottom: 18px !important;
    // text-align: center;
    // // position: absolute;
    // // top: 4%;
    // // left: 50%;
    // // z-index: 1001;
    // // width: 86%;
    // // transform: translateX(-50%);
    // font-size: 16px;
    // color: #fff;
    padding: 18px 0px;
    // border-radius: 8px 8px 0px 0px;
    // background: rgb(100, 164, 255);
    ::v-deep .van-divider {
      margin: 10px 0px !important;
      background: rgb(235, 235, 235) !important;
    }
    .tiPic {
      position: absolute;
      top: -45px;
      left: 50%;
      width: 310px;
      height: 90px;
      transform: translateX(-50%);
    }
  }
  .deta {
    display: flex;
    justify-content: space-between;
  }
  .showD {
    position: fixed;
    top: 0%;
    left: 50%;
    z-index: 1000;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    transform: translateX(-50%);
  }
  .close {
    position: absolute;
    bottom: -70px;
    left: 50%;
    width: 30px;
    height: 30px;
    color: #1989fa;
    font-weight: 600;
    font-size: 18px;
    line-height: 32px;
    text-align: center;
    background: #fff;
    border-radius: 50%;
    transform: translateX(-50%);
  }
  .circle {
    position: absolute;
    top: 0;
    left: 50%;
    z-index: -1;
    width: 80px;
    height: 80px;
    background: #fff;
    border-radius: 50%;
    transform: translate(-50%, -30%);
  }
  .dialogTitle {
    .van-dialog__header {
      padding: 10px 0 !important;
      color: #fff;
      font-weight: 600 !important;
      background: #1989fa;
    }
  }
  .content2 {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 1000;
    width: 344px;
    padding: 39px 0px;
    padding-top: 0px;
    line-height: 24px;
    text-align: left;
    background: #fff;
    border-radius: 10px;
    // max-height: 52%;
    transform: translate(-50%, -50%);
    // height: 100%;
    // overflow-y: auto;
    > div {
      margin-bottom: 8px;
      padding: 0px 20px;
    }
    .conDet {
      // height: 80%;
      max-height: 300px;
      overflow: auto;
      ::v-deep .act {
        box-sizing: border-box;
        padding: 0px 16px;
        > div:nth-last-of-type(1) {
          border-bottom: none !important;
        }
      }
    }
    ::v-deep .van-divider {
      background: rgb(235, 235, 235) !important;
    }
  }
  .btn {
    margin-left: 10px;
  }
  .fildBox {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;
  }
  .fieldListBox {
    padding: 20px;
  }
  .title {
    height: 40px;
    color: #fff;
    font-size: 16px;
    line-height: 40px;
    text-align: center;
    background: #1989fa;
  }
  .fieldItem {
    display: flex;
    align-items: center;
    height: 35px;
    font-size: 18px;
    line-height: 35px;
    border-bottom: 1px solid #ebedf0;
    span {
      margin-left: 5px;
    }
  }
  .look {
    display: flex;
    justify-content: space-between;
  }
}
.add_content {
  margin-top: 54px;
  ::v-deep .van-field__right-icon {
    position: relative;
    top: 1px;
    color: rgb(179, 179, 179);
  }
}
// 必选项*星号
.isRecessary > .van-field:before {
  position: absolute;
  left: 1px;
  color: #ee0a24;
  font-size: 0.37333rem;
  content: "*";
}

.isRecessary {
  margin-bottom: 1px;
  background: #ffffff;
  box-shadow: 0px 1px 0px 0px rgba(238, 238, 238, 1);
  ::v-deep .van-field__label {
    color: #464a4c;
    font-weight: 400;

    font-size: 14px;
    letter-spacing: 0;
  }
  ::v-deep .van-cell {
    padding-right: 0px;
    padding-left: 8px;
  }
  ::v-deep .van-picker-column__item {
    color: rgba(70, 74, 76, 0.7);
    font-weight: 400;

    font-size: 18px;
    letter-spacing: 0;
  }

  ::v-deep .van-picker-column__item--selected {
    color: #464a4c;
    font-weight: 500;

    font-size: 20px;
    letter-spacing: 0;
  }

  ::v-deep .van-picker__cancel {
    color: #464a4c;
    font-weight: 500;

    font-size: 16px;
    letter-spacing: 0;
  }

  ::v-deep .van-picker__confirm {
    color: #208fff;
    font-weight: 500;

    font-size: 16px;
    letter-spacing: 0;
  }
}
.isRecessary.enterGar {
  ::v-deep .van-cell {
    padding-right: 24px;
    padding-left: 8px;
  }
}
.editStudent {
  display: flex;
  justify-content: center;
  margin-top: 24px;
  margin-bottom: 0;
  span {
    position: relative;
    display: block;
    width: 305px;
    height: 44px;
    color: #ffffff;
    font-weight: 700;
    font-size: 18px;
    line-height: 44px;
    letter-spacing: 0;
    text-align: center;
    background-image: linear-gradient(-45deg, #54adfb 0%, #297bf4 100%);
    border-radius: 22px;
  }
  img {
    position: absolute;
    top: 3px;
    left: 0;
    z-index: -1;
    width: 100%;
  }
}

.codedialog {
  ::v-deep .van-popup {
    background-color: transparent;
  }
}
.wrap {
  height: 404px;
  padding-top: 50px;
}

.ti {
  position: relative;
  // color: #fff;
  padding: 18px 0px;
  // text-align: center;
  // position: absolute;
  // top: 4%;
  // left: 50%;
  // z-index: 1001;
  // width: 86%;
  // transform: translateX(-50%);
  font-size: 16px;
  border-radius: 8px 8px 0px 0px;
  // background: url("../assets/img/zfnotice.png");
  // background-size: cover;
  ::v-deep .van-divider {
    margin: 10px 0px !important;
    background: rgb(235, 235, 235) !important;
  }
  #qrCode {
  }
  .tiLogo {
    position: absolute;
    top: -132%;
    left: 50%;
    z-index: 9999;
    box-sizing: border-box;
    width: 310px;
    height: 205px;
    padding-top: 20px;
    background: url("../../assets/img/tyQrcode.png") no-repeat;
    background-size: 100% 100%;
    transform: translateX(-50%);
  }
}
.content {
  width: 344px;
  // border-radius: 8px;
  // position: absolute;
  // top: 50%;
  // left: 50%;
  // width: 72%;
  // max-height: 75%;
  // transform: translate(-50%, -50%);
  // background: #fff;
  // text-align: left;
  // line-height: 24px;
  // ::v-deep .van-divider {
  //   background: rgb(235, 235, 235) !important;
  // }
  height: 100%;
  background: #fff;
  border-radius: 0.42667rem;
  .qrContent {
    width: 304px;
    height: 89px;
    margin: 0 auto;
    .qc_top {
      display: flex;
      justify-content: space-between;
      box-sizing: border-box;
      height: 44px;
      padding: 12px 14px;
      color: #464a4c;
      font-weight: 400;
      align-items: center;

      font-size: 14px;
      letter-spacing: 0;
      border-bottom: 1px solid #eeeeee;
    }
    .qc_bot {
      display: flex;
      justify-content: space-between;
      box-sizing: border-box;
      height: 44px;
      align-items: center;
      padding: 12px 14px;
      color: #464a4c;
      font-weight: 400;
      border-bottom:0.02667rem solid #eeeeee;
      font-size: 14px;
      letter-spacing: 0;
      .qc_money {
        color: #f46c6c;
        font-weight: 500;

        font-size: 14px;
        letter-spacing: 0;
        text-align: right;
      }
    }
  }
  .qrCenter {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 304px;
    height: 44px;
    margin: 0 auto;
    margin-top: 140px;
    color: #464a4c;
    font-weight: 400;

    font-size: 14px;
    letter-spacing: 0;
    background: #f1f1f1;
    border-radius: 10px;
  }
}

.butarea {
  position: absolute;
  // bottom: 41px;
  left: 50%;
  // display: flex;
  padding: 20px 6px;
  padding-bottom: 30px;
  text-align: center;
  transform: translateX(-50%);
  ::v-deep .van-button--info {
    border: none !important;
    outline: none !important;
  }
  // justify-content: space-around;
  .confirm {
    position: relative;
    width: 305px;
    height: 44px;
    margin: 0 auto;
    color: #fff !important;
    color: #ffffff;
    font-weight: 700;

    font-size: 18px;
    letter-spacing: 0;
    background-image: linear-gradient(-45deg, #54adfb 0%, #297bf4 100%);
    border-radius: 22px;
    .blueSha {
      position: absolute;
      top: 68%;
      left: 50%;
      width: 286px;
      height: 34px;
      transform: translateX(-50%);
    }
  }
}
</style>
